import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CheckmarkCircleSVG = function CheckmarkCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6.7,9.58-9,9.82a1,1,0,0,1-1.44,0L8.8,17.53a1.08,1.08,0,0,1,0-1.48,1,1,0,0,1,1.41,0L13,19.19l8.3-9.09a1,1,0,0,1,1.41,0A1.08,1.08,0,0,1,22.7,11.58Z"
  }));
};
CheckmarkCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CheckmarkCircleSVG);